module.exports = __webpack_public_path__ + "images/icon/common_ic_add_block_hover-2b741f52.svg";